<!-- Usando a classe principal do seu CSS -->
<div class="boletim-container" *ngIf="!carregando">
  
  <!-- Usando o cabeçalho do seu CSS -->
  <div class="boletim-header">
    <h3>Relatório de Avaliações</h3>
  </div>

  <!-- Mensagem de 'sem dados' -->
  <div class="no-data" *ngIf="!disciplinasComAvaliacoes || disciplinasComAvaliacoes.length === 0">
    <p>Nenhuma avaliação disponível para este aluno e ano.</p>
  </div>

  <!-- Loop principal que cria uma seção para cada disciplina -->
  <div class="disciplina-section" *ngFor="let disciplina of disciplinasComAvaliacoes" style="padding: 1rem; border-top: 1px solid #e0e0e0;">
    
    <!-- Nome da Disciplina como título da seção -->
    <h4 class="disciplina-nome" style="text-align: left; margin-bottom: 1rem;">{{ disciplina.nomeDisciplina }}</h4>

    <!-- Tabela com as avaliações, usando as classes do seu CSS -->
    <div class="table-wrapper" *ngIf="disciplina.avaliacoes && disciplina.avaliacoes.length > 0">
      <table class="boletim-table">
        <thead>
          <tr>
            <th>Avaliação</th>
            <th>Data</th>
            <th class="col-media">Nota</th>
          </tr>
        </thead>
        <tbody>
          <!-- Loop nas avaliações da disciplina -->
          <tr *ngFor="let avaliacao of disciplina.avaliacoes">
            <td>{{ avaliacao.descricao }}</td>
            <td>{{ avaliacao.dataAplicacao | date:'dd/MM/yyyy' }}</td>
            <td class="nota">{{ avaliacao.nota | number:'1.1-1' }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Mensagem se a disciplina não tiver avaliações -->
    <div class="no-avaliacoes" *ngIf="!disciplina.avaliacoes || disciplina.avaliacoes.length === 0">
        <p style="font-size: 0.875rem; color: #999; text-align: center; padding: 1rem;">Nenhuma avaliação registrada para esta disciplina.</p>
    </div>

  </div>
</div>

<!-- Seção de Loading (usando seu CSS) -->
<div class="loading" *ngIf="carregando">
  <div class="spinner"></div>
  <p>Carregando relatório...</p>
</div>
